module.exports = __webpack_public_path__ + "img/lingbiao_bg.3164cea4.png";